module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Contatos\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "col-md-4"
  }, [(_vm.ehEmailPrefeitura) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                        " + _vm._s(_vm.cadastrado.pessoa.contato.email) + "\n                      ")])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('field-validation', {
    attrs: {
      "label": "Email",
      "field": "email",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false,
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.email),
      expression: "cadastrado.pessoa.contato.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|max:70'),
      expression: "'required|email|max:70'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "none"
    },
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "data-vv-as": "Email",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "email", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dddCelular"
    }
  }, [_vm._v("DDD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.dddCelular),
      expression: "cadastrado.pessoa.contato.dddCelular"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##'),
      expression: "'##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "dddCelular",
      "id": "dddCelular",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.dddCelular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "dddCelular", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "telefoneCelular"
    }
  }, [_vm._v("Tel Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.numeroCelular),
      expression: "cadastrado.pessoa.contato.numeroCelular"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('#####-####'),
      expression: "'#####-####'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "telefoneCelular",
      "id": "telefoneCelular",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.numeroCelular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "numeroCelular", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dddResidencial"
    }
  }, [_vm._v("DDD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.dddTelefone),
      expression: "cadastrado.pessoa.contato.dddTelefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##'),
      expression: "'##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "dddResidencial",
      "id": "dddResidencial",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.dddTelefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "dddTelefone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "telefoneResidencial"
    }
  }, [_vm._v("Tel Fixo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.contato.numeroTelefone),
      expression: "cadastrado.pessoa.contato.numeroTelefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('####-####'),
      expression: "'####-####'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "telefoneResidencial",
      "id": "telefoneResidencial",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.contato.numeroTelefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.contato, "numeroTelefone", $event.target.value)
      }
    }
  })])])])])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca(_vm.cadastrado, 'Documentacao')
      }
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a6c94b4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recadastramento/contatos/index.vue
// module id = hwPX
// module chunks = 5